import { inject, Injectable } from '@angular/core';
import { MembershipConstantsType, UserModel } from '@app/models/server/user.model';
import { Observable } from 'rxjs';
import { CampaignDataModal, ContainerModel } from '@app/models/server/layout.model';
import { HttpClientService } from '@app/api-v2/util/http/http-client.service';
import { FieldResponse } from '@app/models/client/notification.model';

@Injectable()
export class UserDashboardService {
  private httpClientService: HttpClientService;

  constructor() {
    this.httpClientService = inject(HttpClientService);
  }

  getUserMembershipData(): Observable<MembershipConstantsType> {
    return this.httpClientService.get(
      `user-service/fetch/user/active-membership`,
      {},
    );
  }

  getMyCoupons(couponIds: string[]): Observable<ContainerModel[]> {
    return this.httpClientService.post(
      `coupon/find-coupons-by-ids`,
      {
        couponIds,
      },
      {},
    );
  }

  getUserData(): Observable<UserModel> {
    return this.httpClientService.get(`user-service/fetch/user`, {});
  }

  inviteYourFriend(emailId: string): Observable<{ success: boolean }> {
    return this.httpClientService.post(
      `dashboard/order-service/send/order/referred/email`,
      {
        emailId,
      },
      {},
    );
  }

  deleteAccount(): Observable<{ success: boolean }> {
    return this.httpClientService.delete(`user-service/delete-user`, {});
  }

  initFeatureBookingListPage(body: any): Observable<ContainerModel[]> {
    return this.httpClientService.post(`get-customer-order-list`, body, {});
  }

  initFeatureWishListPage(): Observable<ContainerModel[]> {
    return this.httpClientService.post(
      `product-service/get-property-wish-list`,
      {},
      {},
    );
  }

  initGiftCardPage(): Observable<ContainerModel[]> {
    return this.httpClientService.get(`coupon-service/user/gift-cards`, {});
  }

  updateUserData(body: {
    questionKey: string;
    valueList?: any[];
    valueDate?: string;
  }): Observable<FieldResponse> {
    return this.httpClientService
      .post('user-service/update-user-form-answers', body, {})
      .pipe();
  }

  getUserCampaignData(): Observable<CampaignDataModal> {
    return this.httpClientService.post(
      `user-service/fetch-campaign-winners`,
      {},
      {},
    );
  }
}
